import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image } from "@zillow/constellation-10";
import { v8ResponsiveToPanda } from "../../utils/token-migration/migrate-responsive.esm.js";
const baseBackgroundImageClass = css({
  pointerEvents: "none",
  position: "absolute",
  top: "0",
  right: "0",
  bottom: "0",
  left: "0",
  width: "100%",
  height: "100%",
  // The constellation `.c11n` base reset applies `all: unset`, which wipes the
  // <img>'s user-agent `overflow: clip` — the default that crops object-fit
  // (cover/contain) overflow to the element box. Without it the scaled image
  // paints OUTSIDE its 500px box and visually bleeds into adjacent groups even
  // though the box itself is correctly sized. Re-clip explicitly (this class is
  // in @layer utilities, so it beats the @layer base reset).
  overflow: "hidden"
});
const fitPositionClass = css({
  objectFit: "[var(--gbi-fit-base)]",
  objectPosition: "[var(--gbi-pos-base)]",
  md: {
    objectFit: "[var(--gbi-fit-md, var(--gbi-fit-base))]",
    objectPosition: "[var(--gbi-pos-md, var(--gbi-pos-base))]"
  },
  xl: {
    objectFit: "[var(--gbi-fit-xl, var(--gbi-fit-md, var(--gbi-fit-base)))]",
    objectPosition: "[var(--gbi-pos-xl, var(--gbi-pos-md, var(--gbi-pos-base)))]"
  }
});
function resolveFitPos(value, fallbackBase) {
  const resolved = value && typeof value === "object" ? v8ResponsiveToPanda(value) : {
    base: typeof value === "string" ? value : void 0
  };
  const clean = (v) => v && v !== "none" ? v : void 0;
  return {
    base: clean(resolved.base) ?? fallbackBase,
    md: clean(resolved.md),
    xl: clean(resolved.xl)
  };
}
function resolveDisplay(visible) {
  if (!visible) return void 0;
  if (typeof visible === "object") {
    return v8ResponsiveToPanda(visible, (v) => v ? "initial" : "none");
  }
  return void 0;
}
const GroupBackgroundImage = ({
  backgroundPosition = "50% 50%",
  backgroundSize = {
    default: "cover"
  },
  backgroundImageVisible,
  className,
  style,
  ...rest
}) => {
  const fit = resolveFitPos(backgroundSize, "cover");
  const pos = resolveFitPos(backgroundPosition, "50% 50%");
  const display = resolveDisplay(backgroundImageVisible);
  const displayClass = display ? css({
    display
  }) : void 0;
  return /* @__PURE__ */ jsx(Image, { alt: "", className: [baseBackgroundImageClass, fitPositionClass, displayClass, className].filter(Boolean).join(" "), style: {
    height: "100%",
    "--gbi-fit-base": fit.base,
    ...fit.md ? {
      "--gbi-fit-md": fit.md
    } : {},
    ...fit.xl ? {
      "--gbi-fit-xl": fit.xl
    } : {},
    "--gbi-pos-base": pos.base,
    ...pos.md ? {
      "--gbi-pos-md": pos.md
    } : {},
    ...pos.xl ? {
      "--gbi-pos-xl": pos.xl
    } : {},
    ...style
  }, ...rest });
};
export {
  GroupBackgroundImage as default
};
